export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'SegmentCategory';
export const NAME = 'SegmentCategory';
